import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "prod-cost" };
const _hoisted_2 = { class: "prod-cost__wrap" };
const _hoisted_3 = { class: "prod-cost__price" };
const _hoisted_4 = {
    key: 0,
    class: "prod-cost__price-changes"
};
const _hoisted_5 = { class: "prod-cost__price-discount" };
const _hoisted_6 = { class: "prod-cost__price-old" };
const _hoisted_7 = { class: "prod-cost__price-new" };
const _hoisted_8 = { class: "prod-cost__parts" };
const _hoisted_9 = { class: "prod-cost__parts-value" };
const _hoisted_10 = {
    type: "button",
    class: "btn btn--4 btn--m btn--black btn--link btn--icon win",
    "data-act": "bnpl_info",
    "aria-label": "Подробности"
};
const _hoisted_11 = { class: "btn__icon" };
const _hoisted_12 = { class: "prod-cost__in-cart" };
import handleAddToCartButtonClick from "../../../components/product/add_to_cart";
import Price from "../../../components/Price.vue";
import Icon from "../../../components/Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OfferPrice',
    props: {
        offer: { type: Object, required: true },
        productId: { type: Number, required: true },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (__props.offer.oldPrice)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, "-" + _toDisplayString(__props.offer.discount) + "%", 1 /* TEXT */),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(Price, {
                                        amount: __props.offer.oldPrice
                                    }, null, 8 /* PROPS */, ["amount"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(Price, {
                                amount: __props.offer.price
                            }, null, 8 /* PROPS */, ["amount"])
                        ])
                    ]),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_8, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "prod-cost__parts-label" }, "Оплата 4 равными частями", -1 /* HOISTED */)),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_9, [
                            _cache[3] || (_cache[3] = _createTextVNode("по\n          ")),
                            _createVNode(Price, {
                                amount: Math.floor(__props.offer.price / 4)
                            }, null, 8 /* PROPS */, ["amount"]),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("button", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, [
                                    _createVNode(Icon, {
                                        name: "question",
                                        size: 20
                                    })
                                ])
                            ])
                        ])
                    ]),
                    _cache[9] || (_cache[9] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn--1 btn--l btn--primary",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_unref(handleAddToCartButtonClick)(__props.offer.id)), ["prevent"]))
                        }, _cache[7] || (_cache[7] = [
                            _createElementVNode("span", { class: "btn__label" }, "В корзину", -1 /* HOISTED */)
                        ]))
                    ])
                ])
            ]));
        };
    }
});
